// extracted by mini-css-extract-plugin
export default {"social":"social_social__jJ-vx"};